import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { BehaviorSubject, tap } from 'rxjs';
import { SideDetailViewDirective } from './side-detail-view.directive';
import { SideDetailViewService } from './side-detail-view.service';

@UntilDestroy()
@Component({
  selector: 'y42-container-with-side-detail-view',
  templateUrl: './container-with-side-detail-view.component.html',
  styleUrls: ['./container-with-side-detail-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SideDetailViewService],
  exportAs: 'containerWithSideDetailView',
})
export class ContainerWithSideDetailViewComponent {
  constructor(private readonly service: SideDetailViewService) {}

  @ContentChild(SideDetailViewDirective) sideDetailViewContent!: SideDetailViewDirective;

  private readonly isHeaderHidden$$ = new BehaviorSubject(false);
  private readonly isCloseButtonHidden$$ = new BehaviorSubject(false);

  @Input() set hideHeader(value: boolean) {
    this.isHeaderHidden$$.next(value || (!this.state.titleString && this.isCloseButtonHidden$$.value));
  }
  @Input() set hideCloseButton(value: boolean) {
    this.isCloseButtonHidden$$.next(value);
    this.isHeaderHidden$$.next(value && !this.state.titleString);
  }
  @Input() hasBackdrop = false;
  @Input() mode: MatDrawerMode = 'over';
  @Input() contentClasses: string[] = [];

  readonly state = connectState(this, {
    footer: this.service.footer$,
    isHeaderHidden: this.isHeaderHidden$$,
    isCloseButtonHidden: this.isCloseButtonHidden$$,
    sidenavOpened: this.service.sidenavOpened$,
    titleString: this.service.titleString$.pipe(
      tap(() => {
        this.isHeaderHidden$$.next(false);
      }),
    ),
    titleFormControl: this.service.titleFormControl$.pipe(
      tap(() => {
        this.isHeaderHidden$$.next(false);
      }),
    ),
  });

  open() {
    return this.service.open();
  }

  close() {
    this.service.close();
  }
}
